import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import toast from 'react-hot-toast';
import api from '../services/api';
import { useAuthStore } from '../store/auth.store';

export default function ProfilePage() {
  const { user } = useAuthStore();
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.next !== form.confirm) {
      toast.error('Новые пароли не совпадают');
      return;
    }
    try {
      setSaving(true);
      const res = await api.post('/auth/change-password', {
        currentPassword: form.current,
        newPassword: form.next,
      });
      toast.success(res.data.message || 'Пароль изменён');
      setForm({ current: '', next: '', confirm: '' });
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Не удалось изменить пароль');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography variant="h4" gutterBottom>
        Профиль
      </Typography>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            Email
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5 }}>
            {user?.email}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Роль
          </Typography>
          <Typography variant="body1">
            {user?.role === 'admin' ? 'Администратор' : 'Пользователь'}
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Смена пароля
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              type="password"
              label="Текущий пароль"
              value={form.current}
              onChange={(e) => setForm({ ...form, current: e.target.value })}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              type="password"
              label="Новый пароль"
              value={form.next}
              onChange={(e) => setForm({ ...form, next: e.target.value })}
              margin="normal"
              required
              helperText="Минимум 8 символов, буквы и цифры"
            />
            <TextField
              fullWidth
              type="password"
              label="Повторите новый пароль"
              value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              margin="normal"
              required
            />
            <Button type="submit" variant="contained" disabled={saving} sx={{ mt: 2 }}>
              {saving ? 'Сохранение...' : 'Изменить пароль'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
